/**
 * Toggle password show
 * Turns password field in text field to show content
 */
export default class ShowPasswordToggle {
    constructor() {
        /**
         * DOM elements
         * @type {{passwordToggleTrigger: string, states: {passwordVisible: string}}}
         */
        this.DOM = {
            passwordToggleTrigger: ".js-show-password-toggle",
            states: {
                passwordVisible: "has-password-visible",
            },
        };

        /**
         * get all password toggle triggers
         * @type {NodeListOf<Element>}
         */
        this.passwordToggleTrigger = document.querySelectorAll(
            this.DOM.passwordToggleTrigger,
        );
    }

    /**
     * Init
     */
    init() {
        if (this.passwordToggleTrigger.length < 1) {
            return;
        }
        this.passwordToggle();
    }

    /**
     * Password toggle functionality
     * on toggle click finds nearest
     * input and turns it into type=text
     */
    passwordToggle() {
        for (let i = 0; i < this.passwordToggleTrigger.length; i++) {
            const passwordToggleTrigger = this.passwordToggleTrigger[i];
            const passwordFieldset = passwordToggleTrigger.closest("fieldset");
            const passwordInput = passwordFieldset.querySelector("input");

            passwordToggleTrigger.addEventListener("click", (event) => {
                event.preventDefault();
                if (passwordInput.type === "password") {
                    passwordInput.type = "text";
                    passwordFieldset.classList.add(
                        this.DOM.states.passwordVisible,
                    );
                } else {
                    passwordInput.type = "password";
                    passwordFieldset.classList.remove(
                        this.DOM.states.passwordVisible,
                    );
                }
            });
        }
    }
}
